import React, { Component } from 'react'
import "./activity.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { getApiActivityList } from '../../axios/api';
import { get , remove } from '../../axios/localstorage';



export default class activity extends Component {

    state = {
        page:1,
        total:1,
        list:[],
        name:"",
        nameType:"",
        showNone:false,
    }

    componentWillMount(){
        window.scroll(0,0);

        let nameData = get('name');
        console.log(nameData)
        if(nameData){
            this.setState({
                name:nameData.name,
                nameType:nameData.nameType
            })

            // remove('name')
        }

        this.getList(nameData?nameData.name:"");
        
    }

    getList=(name)=>{
        getApiActivityList({keywords:name})
        .then( req =>{
            if(req.data.code === 1){

                let data = req.data.data;

                this.setState({
                    list:data
                })

                if(data[0].child.length === 0){
                    this.setState({
                        showNone:true
                    })
                }else{
                    this.setState({
                        showNone:false
                    })
                }
            }
        }).catch( err =>{
            console.error(err);
            this.setState({
                showNone:true
            })
        })
    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    gotoInfoPage=(page)=>{
 
        let str = window.location.href;
        var num=str.indexOf("#/") 
        str=str.substr(0,num+1); //取得所有参数   stringvar.substr(start [, length ]

        window.open(str + page);
    }

    changePage=(page)=>{
        this.setState({
            page
        })

    }

    changeName=(name)=>{
        this.getList(name);
    }

    render() {
        return (
            <div className='activity'>
                <Header type={8} name={this.state.name} changeName={this.changeName}  />
                <div className='head'>
                    <div className='cen'>
                        <div className='hmain'>
                            <div className='hname'>
                                <p>当前位置：</p>
                                <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p>科创活动</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='page'>
                    <div className='cen'>
                        <div className='main'>
                            {
                                this.state.list.map((item,index)=>{
                                    return <div className='box' key={index} hidden={item.child.length === 0}>
                                                <div className='name'>
                                                    <img alt="" src="/www/assets/imgs/kechuanghuodong-fenlei.png" />
                                                    <h2>{item.title}</h2>
                                                </div>
                                                <div className='list'>
                                                    {
                                                        item.child.map((elem,num)=>{
                                                            return <div className='item' key={num} onClick={()=>{this.gotoInfoPage("/productinfo?id="+elem.id)}}>
                                                                        <div className='bg' style={{backgroundImage:"url('"+elem.image+"')"}}></div>
                                                                        <div className='info'>
                                                                            <h2>{elem.title}</h2>
                                                                        </div>
                                                                        <div className={elem.is_end === 1?"istatus":"ido istatus"}>{elem.is_end === 1?"已结束":"进行中"}</div>
                                                                    </div>
                                                        })
                                                    }
                                                </div>
                                            </div>
                                })
                            }

                                <div className='none' hidden={!this.state.showNone}>
                                    <div className='cen'>
                                        <img alt="" src="/www/assets/imgs/zanwuxuexineirong.png" />
                                    </div>
                                    <p>暂无相关科创活动</p>
                                </div>
                           
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        )
    }
}
